module.exports = __webpack_public_path__ + "static/demo-image-01-2cf5985b2eaebfad760fbfc3ccec1301.jpg";